import React from 'react';
import { isEmpty } from 'lodash';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import { convertStatusEnumToString } from '@utils/convertor';

const rowsToHide = ['IsDeleted', 'SubjectNumber'];

const SubjectReviewInstances = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;

    const updatedOldRecord = { ...oldRecord, Status: convertStatusEnumToString(oldRecord.Status) };
    const updatedNewRecord = { ...newRecord, Status: convertStatusEnumToString(newRecord.Status) };

    const refactoredOldRecord = updatedOldRecord
        ? {
              ...updatedOldRecord,
              ...removePropertiesFromObject(updatedOldRecord, rowsToHide),
          }
        : updatedOldRecord;

    const refactoredNewRecord = updatedNewRecord
        ? {
              ...updatedNewRecord,
              ...removePropertiesFromObject(updatedNewRecord, rowsToHide),
          }
        : updatedNewRecord;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord,
            newRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export default SubjectReviewInstances;
